import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/system-control/pc/index.vue";
import mobile from "../../../../form/src/common/components/system-control/mobile/index.vue";
const info = {
    title: "拥有者",
    title_i18n: "{\"zh\": \"拥有者\", \"en\": \"Owner\"}",
    type: "ownerId",
    icon: "h-icon-all-user-list-o",
    dataItemType: DataItemType.StaffSingle,
    formControllerType: FormControlType.OwnerId,
    group: "系统控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
